import User from "@phoenixreisen/user";
import m from "mithril";
export default class Footer {
    view() {
        return (m("article", { class: "intern-footer" },
            m("div", { class: "wrapper wrapper--large" },
                m("hr", null),
                User.isLoggedIn() && (m("div", { class: "tr mr3" },
                    m("span", null,
                        "eingeloggt als",
                        " ",
                        m("span", { class: "f4" }, User.getPhxUsername() || "")),
                    m("span", { class: "mh3" }, "|"),
                    m("a", { href: "/cdn/mitarbeiter/login/" },
                        m("i", { class: "fas fa-sign-out-alt mr1" }),
                        " abmelden"))),
                !User.isLoggedIn() && (m("div", { class: "tr mr3" },
                    m("a", { href: "/cdn/mitarbeiter/login/" },
                        m("i", { class: "fas fa-sign-in-alt mr1" }),
                        " anmelden"))))));
    }
}
